import { useMutation } from "react-query";
import { getBackendVersion } from "../../api/version";
import { useEffect, useState } from "react";
import { message, Table } from 'antd';

interface BackendData {
    [key: string]: any;
}

const Version: React.FC = () => {
    const [backendData, setBackendData] = useState<BackendData | null>(null);

    const { mutateAsync: getBackendVersionMutation } = useMutation(
        "getBackendVersion",
        () => {
            return getBackendVersion();
        },
        {
            onSuccess: ({ data }) => {
                setBackendData(data);
            },
            onError: ({ response }) => {
                message.error(response.message ? response.message : "Failed to load backend version");
            },
        }
    );

    useEffect(() => {
        getBackendVersionMutation();
    }, []);

    const columns = [
        {
            title: "Property",
            dataIndex: "property",
            key: "property",
        },
        {
            title: "Value",
            dataIndex: "value",
            key: "value",
        },
    ];

    const dataSource = backendData
        ? Object.keys(backendData).map((property) => ({
            key: property,
            property,
            value: backendData[property],
        }))
        : [];

    return (
        <div>
            <h3>Backend System Information</h3>
            <br />
            <br />
            <br />
            {backendData ? (
                <Table dataSource={dataSource} columns={columns} pagination={false} />
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
};

export default Version;
